import CloseIcon from '@mui/icons-material/Close'
import EmailOutlined from '@mui/icons-material/EmailOutlined'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined'
import { Box, Button, Checkbox, FormControlLabel, Grid, IconButton, Link, TextField } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'
import ImageBanner from 'components/image-banner'
import LogoTheme from 'components/logo-theme'
import GoogleIcon from 'components/svg/google-icon'
import LoginGirlSVG from 'components/svg/login-girl'
import WrapperPermission from 'components/wrapper-permission'
import { useParams } from 'react-router-dom'
import { useStyles } from './styles'
import useComponent from './use-component'

interface IRouteParams {
  token: string
}

const SignIn = () => {
  const classes = useStyles()
  const params = useParams<IRouteParams>()

  const {
    onHandleSubmit,
    showMessage,
    handleMessageClose,
    confirmEmail,
    errors,
    isLoading,
    register,
    isPasswordHidden,
    setIsPasswordHidden,
    isLoadingGoogle,
    login,
    setIsLoadingGoogle,
  } = useComponent(params.token)

  return (
    <Box className={classes.container}>
      <Box className={classes.mainWrapper}>
        <WrapperPermission>
          <Box
            component='form'
            onSubmit={onHandleSubmit}
            noValidate
            data-testid='form'
            className={classes.formBox}
          >
            <LogoTheme />

            {showMessage && (
              <Box className={classes.messageWrapper}>
                <IconButton
                  className={classes.iconWrapper}
                  onClick={handleMessageClose}
                >
                  <CloseIcon />
                </IconButton>
                <span className={classes.messageTextWrapper}>Você acaba de confirmar o email: {confirmEmail}</span>
              </Box>
            )}

            <span className={classes.formTitle}>
              Faça login em sua conta empresarial para autenticar e proteger seus dados privados com segurança.
            </span>

            <Box
              gap='.5rem'
              width='100%'
              display='flex'
              padding='16px 0'
              flexDirection='column'
            >
              <TextField
                label='E-mail'
                required
                id='email'
                type='email'
                autoFocus
                variant='outlined'
                placeholder='Digite seu e-mail'
                disabled={isLoading}
                error={!!errors.email}
                helperText={errors?.email?.message ?? ''}
                style={{ marginBottom: '24px' }}
                {...register('email')}
                InputProps={{
                  startAdornment: (
                    <EmailOutlined
                      color={isLoading ? 'disabled' : 'inherit'}
                      sx={{ marginRight: '12px' }}
                    />
                  ),
                }}
              />

              <TextField
                required
                label='Senha'
                id='password'
                type={isPasswordHidden ? 'password' : 'text'}
                autoComplete='new-password'
                variant='outlined'
                disabled={isLoading}
                error={!!errors.password}
                helperText={errors?.password?.message ?? ''}
                placeholder='Digite sua Senha'
                {...register('password')}
                InputProps={{
                  startAdornment: (
                    <LockOutlinedIcon
                      color={isLoading ? 'disabled' : 'inherit'}
                      sx={{ marginRight: '12px' }}
                    />
                  ),
                  endAdornment: (
                    <IconButton
                      onClick={() => setIsPasswordHidden(!isPasswordHidden)}
                      disabled={isLoading}
                    >
                      {isPasswordHidden ? (
                        <VisibilityOffOutlinedIcon color={isLoading ? 'disabled' : 'inherit'} />
                      ) : (
                        <VisibilityOutlinedIcon />
                      )}
                    </IconButton>
                  ),
                  sx: { paddingRight: '8px' },
                }}
              />

              <Grid container>
                <Grid
                  item
                  xs={12}
                  className={classes.forgotPasswordLink}
                  display='flex'
                  justifyContent='space-between'
                  alignItems='center'
                >
                  <FormControlLabel
                    id='remember'
                    control={<Checkbox disabled={isLoading} />}
                    label='Lembrar'
                    disabled={isLoading}
                    {...register('remember')}
                  />

                  {isLoading ? (
                    <span
                      style={{
                        color: 'rgba(0, 0, 0, 0.38)',
                        cursor: 'default',
                      }}
                    >
                      Esqueceu sua senha?
                    </span>
                  ) : (
                    <Link
                      href='/forgot-password'
                      variant='body1'
                      data-testid='signup-link'
                      underline='none'
                    >
                      Esqueceu sua senha?
                    </Link>
                  )}
                </Grid>
              </Grid>

              <Box className={classes.signIn}>
                <Button
                  fullWidth
                  size='large'
                  type='submit'
                  variant='contained'
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <CircularProgress
                      color='inherit'
                      size={26}
                    />
                  ) : (
                    'ENTRAR'
                  )}
                </Button>

                {/* <span>ou</span>

                <Button
                  className={classes.googleBtn}
                  fullWidth
                  size='large'
                  type='button'
                  variant='outlined'
                  disabled={isLoadingGoogle}
                  onClick={() => {
                    login()
                    setIsLoadingGoogle(true)
                  }}
                >
                  {isLoadingGoogle ? (
                    <CircularProgress
                      color='inherit'
                      size={26}
                    />
                  ) : (
                    <>
                      <GoogleIcon /> <span className={classes.googleText}>CONTINUAR COM CONTA GOOGLE</span>
                    </>
                  )}
                </Button> */}
              </Box>

              {/* <Grid container>
                <Grid
                  item
                  xs={12}
                  className={classes.signupLink}
                >
                  Ainda não tem uma conta?&nbsp;
                  <Link
                    href='/signup'
                    variant='body1'
                    data-testid='signup-link'
                    underline='none'
                  >
                    Crie sua conta
                  </Link>
                </Grid>
              </Grid> */}
            </Box>
          </Box>
        </WrapperPermission>

        <ImageBanner
          title='Conducco é uma maneira eficiente e segura de gerenciar seus dados corporativos.'
          subTitle='Tenha a tranquilidade de saber que suas informações estão protegidas e acessíveis apenas para você, seus colaboradores e parceiros autorizados.'
          banner={<LoginGirlSVG />}
        />
      </Box>
    </Box>
  )
}

export default SignIn
